import React, { useRef,useEffect,useState, useContext } from 'react'
import { Button } from 'primereact/button';     
import { InputTextarea } from 'primereact/inputtextarea';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { createPost } from './../api/axiosPosts'
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import DataContext from '../context/DataContext';
        
   
        

        

const AddPost = () => {
  
  const { fetcherror, setFetcherror } = useContext(DataContext);

  const [postTitle, setPostTitle] = useState("");
  const [postContent, setPostContent] = useState("");

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
  setPostTitle("");
  setPostContent("");
  }, []);
  


  const frontStatusToast = (postTitle,postContent) => {
    if (!postTitle || !postContent ) {
      toast.current.show({severity:'error', summary: 'Error', detail:'Either Title or Content Missing', life: 3000});
    } 
  }
  

  const backStatusToast = (res,req) => {

    if (!res && req) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Post Not Created, Couldnot connect to Database', life: 3000 });
    }
    else {
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Post Created Successfully ', life: 3000 });
    }
  };
  
  
  return (
    <div className="card">
      
      <Toast ref={toast} />
      <Card title="Create New Post">
        <form action=""
          onSubmit={ (e) =>
          {
            
            createPost(e, postTitle, postContent, setFetcherror, setPostTitle, setPostContent)
              .then(
                (res) => {

                  console.log("API rensponses", res);

                  backStatusToast(res.finalData, res.badrequest);

                  if (res.finalData) {
                    // setTimeout(() => { navigate('/posts')}, 700);
                  }
                }
              )
              .catch((error) => { 

                frontStatusToast(postTitle, postContent);
                console.log("Error in Front End",error );
              });

          }}
        >
         
          <InputText
            className='w-full mb-4'
            type="text"
            placeholder="Enter Post Title"
            value={postTitle}
            onChange={(e) => setPostTitle(e.target.value)}

          />
          
        <InputTextarea
          className='w-full h-20rem mb-4 '
          autoResize
          placeholder='Describe your Post'
          value={postContent}
          onChange={(e) => setPostContent(e.target.value)}
          />
          
        <div className='flex flex-row justify-content-end'>
          <Button
              label="Submit"
            role='submit'
            icon="pi pi-check" />
          </div>
          
        </form>
    </Card>
</div>)
}

export default AddPost